<template lang="pug">
  v-layout(align-start)
    v-flex
      v-form
        v-data-table.elevation-6(:headers='headers' item-key='nroExpediente' :items='importacion' :search='search' sort-by='nroExpediente' :footer-props="{itemsPerPageText: 'Importaciones por página'}" :loading='loading' loading-text='Cargando, por favor espere...')
          template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
          template(v-slot:top)
            v-toolbar(flat color='primary' dark)
              v-toolbar-title.justify-center Importaciones
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search', label='Búsqueda', single-line hide-details color='success')
              v-spacer
              // Dialog plus
              v-dialog(v-model='dialog', persistent='', max-width='90%')
                template(v-slot:activator='{ on }')
                  v-btn.mx-2(v-if='validarCrear()', fab dark small color='success', v-on='on')
                    v-icon(dark='') mdi-plus
                v-card(color='grey_1')
                  v-app-bar(dark color='primary')
                    v-toolbar-title.headline {{ formTitle }}
                    v-spacer
                    label(v-if='diasRes') Días Restantes: {{form.diasRestantes}}
                  v-card-text
                    v-row(dense)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black'  v-if="read === false") Asignación de Ordenes
                          v-card-text
                            v-row(dense class='d-flex justify-center' v-if="read === false")
                              v-col(cols='12' sm='12' md='3')
                                v-text-field(dense outlined @keyup.enter='enterClickedOrden' type="Number" min="0" hint="Presione Enter" v-model='codigoOrden' label='Código de Orden' append-icon='mdi-clipboard-text-search')
                              v-col(cols='12' sm='12' md='3')
                                v-btn(color='success' dark style='margin-left:40px' @click='showModalOrden()') Asignación Manual
                            v-row(v-if="read === false")
                              v-col(cols='12' sm='12' md='12')
                                v-data-table.elevation-6(:headers="headersOrdenes" :items='ordenes' locale='ES' :footer-props="{itemsPerPageText: 'Ordenes por página'}")
                                  template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                                  template(v-slot:item.action='{ item }')
                                    v-tooltip(bottom='')
                                      template(v-slot:activator='{ on }')
                                        v-icon.mr-2(color='indigo', @click='showItem(item)' v-on="on") mdi-eye
                                      | Detalle
                                    v-tooltip(bottom='')
                                      template(v-slot:activator='{ on }')
                                        v-icon(color='success', @click='assignItem(item)' v-on="on") mdi-clipboard-arrow-down-outline
                                      | Asignar Documento
                                  template(v-slot:no-data)
                                    h2 Campo de Código vacío
                            p
                            v-row(v-if="add")
                              v-col(cols='12' sm='12' md='12')
                                v-data-table.elevation-6(:headers="headersOrdenes2" :items='ordenes2' locale='ES' :search='search2' :footer-props="{itemsPerPageText: 'Ordenes por página'}")
                                  template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                                  template(v-slot:top='')
                                    v-toolbar(flat color='primary' dark)
                                      v-toolbar-title Ordenes Asignadas
                                      v-divider.mx-4(inset='' vertical='')
                                      v-spacer
                                      v-text-field.text-xs-center(v-model='search2' label='Búsqueda' single-line='' hide-details='' color='#e95d3d')
                                      v-spacer
                                  template(v-slot:item.action='{ item }')
                                    v-tooltip(bottom='')
                                      template(v-slot:activator='{ on }')
                                        v-icon.mr-2(color='indigo', @click='editItem2(item, true)' v-on="on") mdi-eye
                                      | Detalle
                                    v-tooltip(bottom='' v-if="read === false")
                                      template(v-slot:activator='{ on }')
                                        v-icon.mr-2(v-if='validarModificar()', color='warning', @click='editItem2(item, false)' v-on="on") mdi-pencil
                                      | Editar
                                    v-tooltip(bottom='' v-if="read === false")
                                      template(v-slot:activator='{ on }')
                                        v-icon.mr-2(color='error' @click='eliminar(item)' v-on="on") mdi-delete
                                      | Eliminar Documento Asignado
                            v-row(dense class='d-flex justify-end' v-if='add')
                              v-btn(color='success' style='width: 8%' dark @click='abrirCalculadora()')
                                v-icon mdi-jellyfish-outline
                            p
                            v-row(dense)
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined readonly v-model='form.kilogramosGeneralOrd' label='Total de kilogramos' suffix="Kg")
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined readonly v-model='form.piesCubicosGeneralOrd' label='Total de Pies Cúbicos' suffix="ft³")
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined readonly v-model='form.metroCubicoGeneralOrd' label='Total de Metros Cúbicos' suffix="m³")
                            v-row(dense class='d-flex justify-end')
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined readonly v-model='form.totalGeneralOrd' label='TOTAL' prefix="$")
                            v-row(dense class='d-flex justify-start')
                              v-icon.mr-2(color='black') mdi-information-outline
                              h3.texto Un estimado de {{estimado40}} contenedor(es) de 40HQ para la reserva
                              v-divider.mx-4(inset vertical)
                              v-spacer
                              v-icon.mr-2(color='black') mdi-information-outline
                              h3.texto Un estimado de {{estimado20}} contenedor(es) de 20HQ para la reserva
                        p
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Reserva de Contenedores
                          v-card-text
                            v-row(dense class='d-flex justify-center' v-if="read === false")
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined type="number" min="0" v-model='reservaContenedor' label='Nro. Contenedores' hint="Presione Enter" @keyup.enter='enterContainer')
                            v-row(dense)
                              table.tabla(border='0' width='80%' align='center')
                                tr(style="border: 1px solid grey;")
                                  td(align="center")
                                    div
                                      span.bold(style='color: black') Contenedor
                                  td(align="center")
                                    div
                                      span.bold(style='color: black') Sello
                                  td(align="center")
                                    div
                                      span.bold(style='color: black') Tipo
                                  td(align="center" width='18%')
                                    div
                                      span.bold(style='color: black') Capacidad
                                  td(align="center" v-if="read === false")
                                tr(v-for="(contenedor, k) in contenedores" :key="k" align='center')
                                  td.inputt
                                    v-text-field(style='margin-bottom: -13px;' dense outlined v-model='contenedor.contenedorOrd')
                                  td.inputt
                                    v-text-field(style='margin-bottom: -13px;' dense outlined v-model='contenedor.selloOrd')
                                  td.inputt
                                    v-text-field(style='margin-bottom: -13px;' dense outlined v-model='contenedor.tipoContenedorOrd')
                                  td.inputt
                                    v-select(style='margin-bottom: -13px;' dense outlined v-model='contenedor.capacidadContenedorOrd' :items='capacidades' suffix="ft³")
                                  td.input2(v-if="read === false")
                                    v-icon(color='error' @click="deleteRow(k, contenedor)") mdi-delete
                        p
                        v-form(ref='form' v-model='valid' lazy-validation='')
                          v-card(color='white')
                            v-card-subtitle.title(style='color: black') Información Naviera
                            v-card-text
                              v-row(dense)
                                v-col(cols='6' sm='6' md='3')
                                  v-select(dense outlined :readonly='read' v-model='form.agencia' label='Agencia/Forwarding' :items='agenciaArray' @change="changeAgencia" :rules="[v => !!v && v.length > 0 || 'Agencia requerida']")
                                v-col(cols='6' sm='6' md='3')
                                  v-select(dense outlined :readonly='read' v-model='form.naviera' label='Naviera' :items='tarifaArray' @change="changeTarifa" :rules="[v => !!v && v.length > 0 || 'Naviera requerida']")
                                v-col(cols='6' sm='6' md='3')
                                  v-text-field(dense outlined readonly type='number' v-model='form.diasLibres' label='Días Libres')
                                v-col(cols='6' sm='6' md='3')
                                  v-autocomplete(dense outlined :readonly='read' v-model='form.estatusImportacion' label='Estatus de Importación' :items='statusArray' :rules="[v => !!v || 'Estatus requerido']")
                              v-row(dense)
                                v-col(cols='6' sm='6' md='3')
                                  v-text-field(dense outlined :readonly='read' v-model='form.bookingNaviera' label='Booking Naviera' :rules="[v => !!v || 'Booking requerido']")
                                v-col(cols='6' sm='6' md='3')
                                  v-text-field(dense outlined readonly v-model='form.fleteOrd' label='Flete' prefix="$")
                                v-col(cols='6' sm='6' md='3')
                                  v-autocomplete(dense outlined :readonly='read' v-model='form.estatusFlete' label='Estatus' :items='statusFleteArray')
                                v-col(cols='6' sm='6' md='3')
                                  v-text-field(dense outlined :readonly='read' type='number' min="0" v-model='form.cartons' label='Cartons' :rules="cartones")
                          p
                          v-card(color='white')
                            v-card-subtitle.title(style='color: black') Descripciones Generalizadas
                            v-card-text
                              v-row(dense class='d-flex justify-center')
                                v-col(cols='12' sm='12' md='4')
                                  v-autocomplete(dense outlined :readonly='read' v-model='form.uso' label='Nacionalización' :items='usoArray' :rules="[v => !!v || 'Requerido']")
                              v-row(dense)
                                v-col(cols='12' sm='12' md='6')
                                  v-textarea(auto-grow dense outlined :readonly='read' v-model='form.descripcionGeneralizada' label='Descripción de Carga')
                                v-col(cols='12' sm='12' md='6')
                                  v-textarea(auto-grow dense outlined :readonly='read' v-model='form.descripcionNacionalizacion' label='Descripción de Nacionalización')
                          p
                          v-card(color='white')
                            v-card-subtitle.title(style='color: black') Itinerarios Reserva Naviera
                            v-card-text
                              v-row(dense)
                                table.tabla(border='0' width='80%' align='center')
                                  tr(style="border: 1px solid grey;")
                                    td(align="center")
                                      div
                                        span.bold(style='color: black') ETD 1
                                    td(align="center")
                                      div
                                        span.bold(style='color: black') ETA 1
                                    td(align="center")
                                      div
                                        span.bold(style='color: black') ETD 2
                                    td(align="center")
                                      div
                                        span.bold(style='color: black') ETA 2
                                    td(align="center")
                                      div
                                        span.bold(style='color: black') ETA 3
                                  tr(align='center')
                                    td.inputt
                                      div(v-if="!read")
                                        v-dialog(ref='dialogETD1' v-model='modalETD1' :return-value.sync='date' :disabled='form.llegadaETD1' persistent width='300px')
                                          template(v-slot:activator='{ on }')
                                            v-text-field(dense outlined :disabled='form.llegadaETD1' style='margin-bottom: -13px;' v-model='form.fechaETD1' prepend-inner-icon='event' v-on='on')
                                          v-date-picker( v-model='form.fechaETD1' locale="ES")
                                            v-spacer
                                            v-btn(small dark color='red' @click='modalETD1 = false') Cancelar
                                            v-btn(small dark color='success' @click='$refs.dialogETD1.save(date)') Ok
                                      div(v-else)
                                        v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETD1' prepend-inner-icon='event')
                                    td.inputt
                                      div(v-if="!read")
                                        v-dialog(ref='dialogETA1' v-model='modalETA1' :return-value.sync='date' :disabled='form.llegadaETA1' persistent width='300px')
                                          template(v-slot:activator='{ on }')
                                            v-text-field(dense outlined :disabled='form.llegadaETA1' style='margin-bottom: -13px;' v-model='form.fechaETA1' prepend-inner-icon='event' v-on='on')
                                          v-date-picker( v-model='form.fechaETA1' locale="ES")
                                            v-spacer
                                            v-btn(small dark color='red' @click='modalETA1 = false') Cancelar
                                            v-btn(small dark color='success' @click='$refs.dialogETA1.save(date)') Ok
                                      div(v-else)
                                        v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETA1' prepend-inner-icon='event')
                                    td.inputt
                                      div(v-if="!read")
                                        v-dialog(ref='dialogETD2' v-model='modalETD2' :return-value.sync='date' :disabled='form.salidaETD2' persistent width='300px')
                                          template(v-slot:activator='{ on }')
                                            v-text-field(dense outlined :disabled='form.salidaETD2' style='margin-bottom: -13px;' v-model='form.fechaETD2' prepend-inner-icon='event' v-on='on')
                                          v-date-picker( v-model='form.fechaETD2' locale="ES")
                                            v-spacer
                                            v-btn(small dark color='red' @click='modalETD2 = false') Cancelar
                                            v-btn(small dark color='success' @click='$refs.dialogETD2.save(date)') Ok
                                      div(v-else)
                                        v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETD2' prepend-inner-icon='event')
                                    td.inputt
                                      div(v-if="!read")
                                        v-dialog(ref='dialogETA2' v-model='modalETA2' :return-value.sync='date' :disabled='form.llegadaETA2' persistent width='300px')
                                          template(v-slot:activator='{ on }')
                                            v-text-field(dense outlined :disabled='form.llegadaETA2' style='margin-bottom: -13px;' v-model='form.fechaETA2' prepend-inner-icon='event' v-on='on')
                                          v-date-picker( v-model='form.fechaETA2' locale="ES")
                                            v-spacer
                                            v-btn(small dark color='red' @click='modalETA2 = false') Cancelar
                                            v-btn(small dark color='success' @click='$refs.dialogETA2.save(date)') Ok
                                      div(v-else)
                                        v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETA2' prepend-inner-icon='event')
                                    td.inputt
                                      div(v-if="!read")
                                        v-dialog(ref='dialogETA3' v-model='modalETA3' :return-value.sync='date' :disabled='form.llegadaETA3' persistent width='300px')
                                          template(v-slot:activator='{ on }')
                                            v-text-field(dense outlined :disabled='form.llegadaETA3' style='margin-bottom: -13px;' v-model='form.fechaETA3' prepend-inner-icon='event' v-on='on')
                                          v-date-picker( v-model='form.fechaETA3' locale="ES")
                                            v-spacer
                                            v-btn(small dark color='red' @click='modalETA3 = false') Cancelar
                                            v-btn(small dark color='success' @click='$refs.dialogETA3.save(date)') Ok
                                      div(v-else)
                                        v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETA3' prepend-inner-icon='event')
                                  tr(align='center')
                                    td.inputt
                                      div(v-if="editedIndex === -1")
                                        v-autocomplete(dense outlined :disabled='form.llegadaETD1' :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETD1' label='País' :items='paisETD1Array' @change="changePaisETD1")
                                      div(v-else)
                                        v-autocomplete(dense outlined :disabled='form.llegadaETD1' :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETD1._id' label='País' :items='paisETD1Array' @change="changePaisETD1")
                                    td.inputt
                                      div(v-if="editedIndex === -1")
                                        v-autocomplete(dense outlined :disabled='form.llegadaETA1' :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA1' label='País' :items='paisETA1Array' @change="changePaisETA1")
                                      div(v-else)
                                        v-autocomplete(dense outlined :disabled='form.llegadaETA1' :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA1._id' label='País' :items='paisETA1Array' @change="changePaisETA1")
                                    td.inputt
                                      div(v-if="editedIndex === -1")
                                        v-autocomplete(dense outlined readonly style='margin-bottom: -13px;' v-model='form.paisETA1' label='País' :items='paisETA1Array' @change="changePaisETA1")
                                      div(v-else)
                                        v-autocomplete(dense outlined readonly style='margin-bottom: -13px;' v-model='form.paisETA1._id' label='País' :items='paisETA1Array' @change="changePaisETA1")
                                    td.inputt
                                      div(v-if="editedIndex === -1")
                                        v-autocomplete(dense outlined :disabled='form.llegadaETA2' :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA2' label='País' :items='paisETA2Array' @change="changePaisETA2")
                                      div(v-else)
                                        v-autocomplete(dense outlined :disabled='form.llegadaETA2' :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA2._id' label='País' :items='paisETA2Array' @change="changePaisETA2")
                                    td.inputt
                                      v-text-field(dense outlined :disabled='form.llegadaETA3' :readonly='read' style='margin-bottom: -13px;' v-model='form.almacenLlegada' label='Almacen de llegada')
                                  tr(align='center')
                                    td.inputt
                                      v-autocomplete(dense outlined :disabled='form.llegadaETD1' :readonly='read' style='margin-bottom: -13px;' v-model='form.puertoETD1' label='Puerto' :items='puertoETD1Array')
                                    td.inputt
                                      v-autocomplete(dense outlined :disabled='form.llegadaETA1' :readonly='read' style='margin-bottom: -13px;' v-model='form.puertoETA1' label='Puerto' :items='puertoETA1Array')
                                    td.inputt
                                      v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.puertoETA1' label='Puerto' :items='puertoETA1Array')
                                    td.inputt
                                      v-autocomplete(dense outlined :disabled='form.llegadaETA2' :readonly='read' style='margin-bottom: -13px;' v-model='form.puertoETA2' label='Puerto' :items='puertoETA2Array')
                                    td.inputt
                                      v-text-field(dense outlined :disabled='form.llegadaETA3' :readonly='read' style='margin-bottom: -13px;' type='time' color='success' v-model='form.horaIngreso' label='Hora Ingreso')
                                  tr(align='center')
                                    td
                                      v-checkbox.check(dense outlined :readonly='read' v-model='form.llegadaETD1' label='Llegada ETD 1' color="success")
                                    td
                                      v-checkbox.check(dense outlined :readonly='read' v-model='form.llegadaETA1' label='Llegada ETA 1' color="success")
                                    td
                                      v-checkbox.check(dense outlined :readonly='read' v-model='form.salidaETD2' label='Salida ETD 2' color="success")
                                    td
                                      v-btn(color='success' small dark :disabled='fechasLlenas' @click='infoAtraque()')
                                        | Atraque
                                    td
                                      v-checkbox.check(dense outlined :readonly='read' v-model='form.llegadaETA3' label='Llegada ETA 3' color="success")
                              v-row(dense class='d-flex justify-center')
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense outlined :readonly='read' v-model='form.transito' label='Tránsito de Importación' suffix="Días")
                              v-row(dense class='d-flex justify-start')
                                v-col(cols='6' sm='6' md='4')
                                  v-btn(color='success' dark @click='abrirRoleo()')
                                    | Roleo
                          p
                          v-card(color='white')
                            v-card-subtitle.title(style='color: black') Documentación Aduana
                            v-card-text
                              v-row(dense class='d-flex justify-center')
                                v-col(cols='6' sm='6' md='4')
                                  v-select(dense outlined :readonly='read' v-model='form.docAduana' :items='statusCorreoArray' label='Estatus de Correo' :rules="[v => !!v || 'Estatus requerido']")
                          p
                          v-card(color='white')
                            v-card-subtitle.title(style='color: black') Datos de BL
                            v-card-text
                              v-row(dense)
                                v-col(cols='6' sm='6' md='4' v-if="editedIndex === -1")
                                  v-select(dense outlined :readonly='read' v-model='form.shipper' label='Shipper' :items='shipperArray' @change="changeShipper" :rules="[v => !!v && v.length > 0 || 'Shipper requerido']")
                                v-col(cols='6' sm='6' md='4' v-else)
                                  v-autocomplete(dense outlined :readonly='read' v-model='form.shipper._id' label='Shipper' :items='shipperArray' @change="changeShipper")
                                v-col(cols='6' sm='6' md='4' v-if="editedIndex === -1")
                                  v-select(dense outlined :readonly='read' v-model='form.consignee' label='Consignatario' :items='consigneeArray' @change="changeConsignee" :rules="[v => !!v && v.length > 0 || 'Agente requerido']")
                                v-col(cols='6' sm='6' md='4' v-else)
                                  v-autocomplete(dense outlined :readonly='read' v-model='form.consignee._id' label='Consignatario' :items='consigneeArray' @change="changeConsignee")
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense outlined readonly v-model='form.nombreEncargado' label='Encargado')
                              v-row(dense)
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense outlined :readonly='read' v-model='form.bl' label='BL #')
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense outlined :readonly='read' v-model='form.bl2' label='Segundo BL #')
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense outlined :readonly='read' v-model='form.nroViaje' label='Nro de Viaje' :rules="[v => !!v || 'Nro de Viaje requerido']")
                              v-row(dense class='d-flex justify-end')
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(v-if="editedIndex !== -1" dense outlined readonly v-model='form.nroExpediente' label='Nro de Expediente')
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense outlined :readonly='read' v-model='form.barco' label='Barco' :rules="[v => !!v || 'Barco requerido']")
                  v-card-actions
                    v-btn(color='error', small dark @click='close()')
                      v-icon mdi-close
                      | Cancelar
                    v-spacer
                    v-btn(color='blue', small dark @click='paso2')
                      | Continuar
                      v-icon mdi-arrow-right-thick
              // Dialog de para datos de la orden de importación
              v-dialog(v-model='dialog3', persistent='', max-width='80%')
                v-form(ref='form2' v-model='valid' lazy-validation='')
                  v-card(color='grey_1')
                    v-app-bar(dark color='primary')
                      v-toolbar-title.headline Orden de Compra #
                        label {{importacionAux.codigoOrd}}
                    v-card-text
                      v-row(dense)
                        v-col(cols='12')
                          v-card(color='white')
                            v-card-text
                              v-row(dense)
                                v-col(cols='6' sm='6' md='3' v-if='manual===false')
                                  v-text-field(dense outlined readonly v-model='importacionAux.fechaCyEOrd' label='Fecha cierre y envío' prepend-inner-icon='event')
                                v-col(cols='6' sm='6' md='3' v-else)
                                  div(v-if="!read2")
                                    v-dialog(ref='dialogFechaCierreEnvio' v-model='modalFechaCierreEnvio' :return-value.sync='date' persistent width='300px')
                                      template(v-slot:activator='{ on }')
                                        v-text-field(dense outlined v-model='importacionAux.fechaCyEOrd' label='Fecha cierre y envío' prepend-inner-icon='event' v-on='on')
                                      v-date-picker( v-model='importacionAux.fechaCyEOrd' locale="ES")
                                        v-spacer
                                        v-btn(small dark color='red' @click='modalFechaCierreEnvio = false') Cancelar
                                        v-btn(small dark color='success' @click='$refs.dialogFechaCierreEnvio.save(date)') Ok
                                  div(v-else)
                                    v-text-field(dense outlined readonly v-model='importacionAux.fechaCyEOrd' label='Fecha cierre y envío' prepend-inner-icon='event')
                                v-col(cols='6' sm='6' md='3')
                                  v-text-field(dense outlined :readonly='read2' v-model='importacionAux.proveedorOrd.nombre' label='Proveedor')
                                v-col(cols='6' sm='6' md='3' v-if='manual===false')
                                  v-text-field(dense outlined readonly v-model='importacionAux.totalOrd' label='Monto FOB' prefix="$")
                                v-col(cols='6' sm='6' md='3' v-else)
                                  v-text-field(dense outlined :readonly='read2' type='number' min='0' v-model='importacionAux.totalOrd' label='Monto FOB' prefix="$")
                                v-col(cols='6' sm='6' md='3')
                                  v-text-field(dense outlined :readonly='read2' v-model='importacionAux.facturaProvOrd' label='# Factura Proveedor' :rules="[v => !!v || 'Factura requerida']")
                              v-row(dense)
                                v-col(cols='6' sm='6' md='3' v-if='manual===false')
                                  v-text-field(dense outlined :readonly='read2' v-model='importacionAux.kilogramosOrd' label='Total Peso' suffix="Kg" :rules="kilos")
                                v-col(cols='6' sm='6' md='3' v-else)
                                  v-text-field(dense outlined :readonly='read2' type='number' min='0' v-model='importacionAux.kilogramosOrd' label='Total Peso' suffix="Kg" :rules="kilos")
                                v-col(cols='6' sm='6' md='3' v-if='manual===false')
                                  v-text-field(dense outlined :readonly='read2' v-model='importacionAux.piesCubicosOrd' label='Total Pies Cúbicos' suffix="ft³" :rules="pies")
                                v-col(cols='6' sm='6' md='3' v-else)
                                  v-text-field(dense outlined :readonly='read2' type='number' min='0' v-model='importacionAux.piesCubicosOrd' label='Total Pies Cúbicos' suffix="ft³" :rules="pies")
                                v-col(cols='6' sm='6' md='3')
                                  v-text-field(dense outlined readonly v-model='importacionAux.metroCubicoOrd' label='Total Metro Cúbicos' suffix="m³")
                                v-col(cols='6' sm='6' md='3' v-if='manual===false')
                                  v-text-field(dense outlined :readonly='read2' v-model='importacionAux.piezasOrd' label='Cantidad de Piezas' :rules="piezas")
                                v-col(cols='6' sm='6' md='3' v-else)
                                  v-text-field(dense outlined :readonly='read2' type='number' min='0' v-model='importacionAux.piezasOrd' label='Cantidad de Piezas' :rules="piezas")
                              v-row(dense)
                                v-col(cols='12' sm='12' md='12')
                                  v-textarea(auto-grow dense outlined :readonly='read2' v-model='importacionAux.descripcionProdOrd' label='Descripción de Productos' :rules="[v => !!v || 'Descripción requerida']")
                    v-card-actions
                      v-btn(color='error' small dark @click='close3')
                        v-icon mdi-close
                        | Cancelar
                      v-spacer
                      v-btn(color='success' v-if="read2 === false" style="margin-right: 1%" dark @click='save2()')
                        v-icon mdi-content-save
                        | Asignar
              // Dialog de info de atraque
              v-dialog(v-model='dialog4', persistent='', max-width='70%')
                v-card(color='grey_1')
                  v-app-bar(dark color='primary')
                    v-toolbar-title.sub-head Información de atraque
                  v-divider
                  v-card-text
                    v-row(dense)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-text
                            v-row(dense)
                              v-col(cols='6' sm='6' md='3' v-if="!read")
                                v-dialog(ref='dialogAtraque' v-model='modalAtraque' :return-value.sync='date' readonly persistent width='300px')
                                  template(v-slot:activator='{ on }')
                                    v-text-field(dense outlined readonly v-model='atraque.fechaATA' label='Fecha de Atraque' prepend-inner-icon='event' v-on='on')
                                  v-date-picker( v-model='atraque.fechaATA' locale="ES")
                                    v-spacer
                                    v-btn(small dark color='red' @click='modalAtraque = false') Cancelar
                                    v-btn(small dark color='success' @click='$refs.dialogAtraque.save(date)') Ok
                              v-col(cols='6' sm='6' md='3' v-else)
                                v-text-field(dense outlined readonly v-model='atraque.fechaATA' label='Fecha de Atraque' prepend-inner-icon='event')
                              v-col(cols='6' sm='6' md='3' v-if="editedIndex === -1")
                                v-autocomplete(dense outlined :readonly='read' v-model='atraque.agencia' label='Agencia' :items='agenciaAtraqueArray' @change="changeAgenciaAtraque")
                              v-col(cols='6' sm='6' md='3' v-else-if="editedIndex !== -1 && !form.atraque.fechaATA")
                                v-autocomplete(dense outlined :readonly='read' v-model='atraque.agencia' label='Agencia' :items='agenciaAtraqueArray' @change="changeAgenciaAtraque")
                              v-col(cols='6' sm='6' md='3' v-else-if="editedIndex !== -1 && form.atraque.fechaATA")
                                v-autocomplete(dense outlined :readonly='read' v-model='atraque.agencia._id' label='Agencia' :items='agenciaAtraqueArray' @change="changeAgenciaAtraque")
                              v-col(cols='6' sm='6' md='3' v-if="editedIndex === -1")
                                v-autocomplete(dense outlined :readonly='read' v-model='atraque.naviera' label='Naviera' :items='navieraAtraqueArray' @change="changeNavieraAtraque")
                              v-col(cols='6' sm='6' md='3' v-else-if="editedIndex !== -1 && !form.atraque.fechaATA")
                                v-autocomplete(dense outlined :readonly='read' v-model='atraque.naviera' label='Naviera' :items='navieraAtraqueArray' @change="changeNavieraAtraque")
                              v-col(cols='6' sm='6' md='3' v-else-if="editedIndex !== -1 && form.atraque.fechaATA")
                                v-autocomplete(dense outlined :readonly='read' v-model='atraque.naviera._id' label='Naviera' :items='navieraAtraqueArray' @change="changeNavieraAtraque")
                              v-col(cols='12' sm='12' md='3')
                                v-text-field(dense outlined :readonly='read'  v-model='atraque.registroSidunea' label='Registro Sidunea')
                            v-row(dense)
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined :readonly='read' v-model='atraque.barco' label='Barco')
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined :readonly='read' v-model='atraque.nroViaje' label='Nro de Viaje')
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense outlined :readonly='read' v-model='atraque.almacen' label='Almacen')
                            v-row(dense class='d-flex justify-center')
                              v-col(cols='12' sm='12' md='4')
                                v-checkbox.check(dense outlined :readonly='read' v-model='form.llegadaETA2' label='Confirmar Atraque' color="success")
                  v-card-actions
                    v-btn(color='error' dark @click='closeAtraque()')
                      v-icon mdi-close
                      | Cancelar
                    v-spacer
                    v-btn(color='success' v-if="read === false && form.llegadaETA2" dark @click='saveAtraque()')
                      v-icon mdi-content-save
                      | Guardar
          template(v-slot:item.action='{ item }')
            v-tooltip(bottom='')
              template(v-slot:activator='{ on }')
                v-icon.mr-2(color='indigo', @click='editItem(item, true)' v-on="on") mdi-eye
              | Detalles
            v-tooltip(bottom='')
              template(v-slot:activator='{ on }')
                v-icon.mr-2(v-if='validarModificar()', color='warning', @click='editItem(item, false)' v-on="on") mdi-pencil
              | Editar
            v-tooltip(bottom='')
              template(v-slot:activator='{ on }')
                v-icon.mr-2(@click='imprimirPDF(item)' color='success' v-on="on") mdi-clipboard-file
              | Expediente de Importación
          template(v-slot:no-data='')
            h1 No hay datos de Importaciones asociadas
      ImportacionP2(:dialogImportacionP2='dialogImportacionP2' @close='closePaso2' @closeTodoP2='closeTodoP2' @closeSave2='closeSave2')
      Calculadora(:dialogCalculadora='dialogCalculadora' @closeCalculadora='closeCalculadora' @saveCalculadora='saveCalculadora' @finalizarCalculadora='finalizarCalculadora')
      ImportacionExpediente(:dialogImportacionExpediente='dialogImportacionExpediente' @closeExpediente='closeExpediente')
      Loading(:dialogLoading='dialogLoading')
      ImportacionDetalleProOrd(:dialogDetalleProOrd='dialogDetalleProOrd' @closeDetalleProOrd='closeDetalleProOrd' :FormDetalleProOrd='formOrden')
      ImportacionRoleo(:dialogRoleo='dialogRoleo' @closeRoleo='closeRoleo' @saveRoleo='saveRoleo')
</template>

<script>
import Api from '@/services/methods'
import ImportacionP2 from '../components/ImportacionP2'
import Calculadora from '../components/modals/Calculadora'
import ImportacionExpediente from '../components/reportes/ImportacionExpediente'
import Loading from '../components/Loading'
import ImportacionDetalleProOrd from '../components/modals/ImportacionDetalleProOrd'
import ImportacionRoleo from '../components/modals/ImportacionRoleo'
import { EventBus } from '../Events'
export default {
  data: () => ({
    valid: true,
    // validaciones Rules form
    cartones: [
      v => !!v || 'Cartones requeridos',
      v => (v && v > 0) || 'Mayor a 0'
    ],
    // validaciones Rules form.importacion
    // acomodar expresion con las comas ","
    kilos: [
      v => !!v || 'Peso requerido',
      v => (v && v > 0) || 'El peso debe ser mayor a 0',
      v => /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)$/g.test(v) || 'Para los decimales, utilice el punto " . "'
    ],
    pies: [
      v => !!v || 'Pie cúbico requerido',
      v => (v && v > 0) || 'El pie cúbico debe ser mayor a 0',
      v => /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)$/g.test(v) || 'Para los decimales, utilice el punto " . "'
    ],
    piezas: [
      v => !!v || 'Piezas requeridas',
      v => (v && v > 0) || 'Las Piezas deben ser mayores a 0',
      v => /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)$/g.test(v) || 'Para los decimales, utilice el punto " . "'
    ],
    dialogDetalleProOrd: false, // Producto de las ordenes de compra
    dialogImportacionExpediente: false, // Reporte
    dialogRoleo: false, // Roleo
    dialogCalculadora: false,
    dialogImportacionP2: false,
    dialog: false,
    dialog3: false,
    dialog4: false,
    dialogETD1: false, // fechas
    modalETD1: false,
    dialogETA1: false,
    modalETA1: false,
    dialogETD2: false,
    modalETD2: false,
    dialogETA2: false,
    modalETA2: false,
    dialogETA3: false,
    modalETA3: false,
    dialogFechaCierreEnvio: false,
    modalFechaCierreEnvio: false,
    dialogAtraque: false,
    modalAtraque: false, // fechas
    dialogLoading: false,
    read: false,
    read2: false,
    date: new Date().toISOString().substr(0, 10),
    search2: '',
    loading: true,
    diasRes: false,
    codigoOrden: '',
    shipperArray: [],
    proveedor: [],
    consigneeArray: [],
    consignados: [],
    agenciaArray: [],
    agencias: [],
    navieras: [],
    tarifas: [],
    tarifasAux: [],
    tarifaArray: [],
    importacion: [],
    ordenes: [],
    ordenes2: [],
    pais: [],
    paisETD1Array: [],
    puertoETD1Array: [],
    paisETA1Array: [],
    puertoETA1Array: [],
    paisETA2Array: [],
    puertoETA2Array: [],
    add: false,
    estimado40: 0,
    estimado20: 0,
    img: '',
    importacionAux: {
      proveedorOrd: {
        co_prov: '',
        nombre: '',
        rif: '',
        ciudad: '',
        telefonos: null,
        direccion: '',
        correo: null
      }
    },
    fechasLlenas: true,
    agenciaAtraqueArray: [],
    navieraAtraqueArray: [],
    selecNaviera: '',
    atraque: {
      agencia: [],
      naviera: [],
      fechaATA: '',
      barco: '',
      nroViaje: '',
      registroSidunea: '',
      almacen: ''
    },
    statusArray: ['Preparación Pedido PROVEEDOR POR CARGAR', 'Reservación BL/NAVIERA', 'En Tránsito', 'Alerta NACIONALIZACIÓN'],
    statusFleteArray: ['Prepagado', 'Por Pagar'],
    statusCorreoArray: ['Si', 'No'],
    usoArray: ['USO 23', 'USO 24'],
    capacidades: [2690, 1317],
    headers: [
      { text: 'Nro Expediente', value: 'nroExpediente', align: 'center' },
      { text: 'ETD 1', value: 'fechaETD1', align: 'center' },
      { text: 'ETA 3', value: 'fechaETA3', align: 'center' },
      { text: 'Tránsito', value: 'transito', align: 'center' },
      { text: 'Estatus', value: 'estatusImportacion', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    headersOrdenes: [
      { text: 'Nro. Orden', value: 'codigoOrd', align: 'center' },
      { text: 'Proveedor', value: 'proveedorOrd.nombre', align: 'center' },
      { text: 'Fecha Emisión', value: 'fec_emis', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    headersOrdenes2: [
      { text: 'Nro. Orden', value: 'codigoOrd', align: 'center' },
      { text: 'Proveedor', value: 'proveedorOrd.nombre', align: 'center' },
      { text: 'Fecha cierre y envío', value: 'fechaCyEOrd', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    search: '',
    permisosImportacion: {},
    editedIndex: -1,
    modificar: false,
    idForm: '',
    manual: false,
    contenedores: [{
      contenedorOrd: '',
      selloOrd: '',
      tipoContenedorOrd: 'High Cube',
      capacidadContenedorOrd: 0,
      piezasContenedorOrd: 0,
      pesoContenedorOrd: 0,
      piesCubicosContenedorOrd: 0
    }],
    reservaContenedor: 0,
    form: { // form importaciones
      barco: '',
      nroViaje: '',
      bl: '',
      bl2: '',
      calculadora: {},
      piezasGeneralOrd: 0, // acumuladores segun data table de asignadas
      totalGeneralOrd: 0,
      piesCubicosGeneralOrd: 0,
      kilogramosGeneralOrd: 0,
      metroCubicoGeneralOrd: 0, // acumuladores segun data table de asignadas
      piezasGeneralContenedor: 0, // acumuladores segun contenedores en paso 4
      totalGeneralContenedor: 0,
      piesCubicosGeneralContenedor: 0,
      kilogramosGeneralContenedor: 0,
      metroCubicoGeneralContenedor: 0, // acumuladores segun contenedores en paso 4
      shipper: [],
      consignee: [],
      nombreEncargado: '',
      contenedores: [],
      agencia: '',
      naviera: '',
      bookingNaviera: '',
      diasLibres: 0,
      fechaETD1: '',
      fechaETA1: '',
      fechaETD2: '',
      fechaETA2: '',
      fechaETA3: '',
      diasETD1ETA1: 0,
      diasETA1ETD2: 0,
      diasETD2ETA2: 0,
      diasETA2ETA3: 0,
      diasRestantes: 0,
      paisETD1: [],
      paisETA1: [],
      paisETD2: [],
      paisETA2: [],
      puertoETD1: null,
      puertoETA1: null,
      puertoETD2: null,
      puertoETA2: null,
      llegadaETD1: false,
      llegadaETA1: false,
      salidaETD2: false,
      llegadaETA2: false,
      llegadaETA3: false,
      almacenLlegada: '',
      estatusImportacion: '',
      transito: '',
      fleteOrd: 0,
      estatusFlete: '',
      cartons: 0,
      horaIngreso: '',
      docAduana: '',
      roleo: [],
      gastos: {
        gastosLocales: [], // Gastos Origen-Destino
        gastosDestino: [],
        gastoCotizacionTotal: 0,
        gastoMontoTotal: 0,
        preliquidacion: 0, // Gasto Nacionalizacion
        manejoCarga: 0,
        seguridadVigilancia: 0,
        despachoCargaContenedor: 0,
        posicionamiento: 0,
        totalPreliquidacion: 0,
        alcances: [], // Gasto Alcances
        totalAlcance: 0,
        tasaServicio: 0, // Tasa e Impuestos
        impuestoImportacion: 0,
        totalTasaImpuesto: 0,
        depositoG: 0, // Gastos Flete internacional
        estatusDepositoG: 0
      },
      archivo: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      },
      uso: '',
      descripcionGeneralizada: '',
      descripcionNacionalizacion: '',
      atraque: {},
      nroExpediente: 0,
      importacion: {
        codigoOrd: '',
        fechaCyEOrd: '',
        proveedorOrd: {},
        facturaProvOrd: '',
        productosOrd: [],
        totalOrd: 0,
        kilogramosOrd: 0,
        piesCubicosOrd: 0,
        metroCubicoOrd: 0,
        descripcionProdOrd: '',
        piezasOrd: ''
      }
    },
    defaultForm: {
      barco: '',
      nroViaje: '',
      bl: '',
      bl2: '',
      calculadora: {},
      piezasGeneralOrd: 0, // acumuladores segun data table de asignadas
      totalGeneralOrd: 0,
      piesCubicosGeneralOrd: 0,
      kilogramosGeneralOrd: 0,
      metroCubicoGeneralOrd: 0, // acumuladores segun data table de asignadas
      piezasGeneralContenedor: 0, // acumuladores segun contenedores en paso 4
      totalGeneralContenedor: 0,
      piesCubicosGeneralContenedor: 0,
      kilogramosGeneralContenedor: 0,
      metroCubicoGeneralContenedor: 0, // acumuladores segun contenedores en paso 4
      shipper: [],
      consignee: [],
      nombreEncargado: '',
      contenedores: [],
      agencia: '',
      naviera: '',
      bookingNaviera: '',
      diasLibres: 0,
      fechaETD1: '',
      fechaETA1: '',
      fechaETD2: '',
      fechaETA2: '',
      fechaETA3: '',
      diasETD1ETA1: 0,
      diasETA1ETD2: 0,
      diasETD2ETA2: 0,
      diasETA2ETA3: 0,
      diasRestantes: 0,
      paisETD1: [],
      paisETA1: [],
      paisETD2: [],
      paisETA2: [],
      puertoETD1: null,
      puertoETA1: null,
      puertoETD2: null,
      puertoETA2: null,
      llegadaETD1: false,
      llegadaETA1: false,
      salidaETD2: false,
      llegadaETA2: false,
      llegadaETA3: false,
      almacenLlegada: '',
      estatusImportacion: '',
      transito: '',
      fleteOrd: 0,
      estatusFlete: '',
      cartons: 0,
      horaIngreso: '',
      docAduana: '',
      roleo: [],
      gastos: {
        gastosLocales: [], // Gastos Origen-Destino
        gastosDestino: [],
        gastoCotizacionTotal: 0,
        gastoMontoTotal: 0,
        preliquidacion: 0, // Gasto Nacionalizacion
        manejoCarga: 0,
        seguridadVigilancia: 0,
        despachoCargaContenedor: 0,
        posicionamiento: 0,
        totalPreliquidacion: 0,
        alcances: [], // Gasto Alcances
        totalAlcance: 0,
        tasaServicio: 0, // Tasa e Impuestos
        impuestoImportacion: 0,
        totalTasaImpuesto: 0,
        depositoG: 0, // Gastos Flete internacional
        estatusDepositoG: 0
      },
      archivo: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      },
      uso: '',
      descripcionGeneralizada: '',
      descripcionNacionalizacion: '',
      atraque: {},
      nroExpediente: 0,
      importacion: {
        codigoOrd: '',
        fechaCyEOrd: '',
        proveedorOrd: {},
        facturaProvOrd: '',
        productosOrd: [],
        totalOrd: 0,
        kilogramosOrd: 0,
        piesCubicosOrd: 0,
        metroCubicoOrd: 0,
        descripcionProdOrd: '',
        piezasOrd: ''
      }
    },
    formOrden: { // form Ordenes
      codigoOrd: '',
      fec_emis: '',
      proveedorOrd: '',
      articulos: [
        {
          co_art: '',
          art_des: '',
          total_art: 0
        }
      ]
    },
    defaultFormOrden: {
      codigoOrd: '',
      fec_emis: '',
      proveedorOrd: '',
      articulos: [
        {
          co_art: '',
          art_des: '',
          total_art: 0
        }
      ]
    }
  }),

  components: {
    ImportacionP2,
    Calculadora,
    ImportacionExpediente,
    Loading,
    ImportacionDetalleProOrd,
    ImportacionRoleo
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Importación'
        : this.read
          ? 'Información de la Importación'
          : 'Modificar Importación'
    }
  },

  watch: {
    'importacionAux.piesCubicosOrd': function (val) {
      if (val) {
        this.importacionAux.metroCubicoOrd = parseFloat(this.importacionAux.metroCubicoOrd)
        let mt = val / 35.315
        this.importacionAux.metroCubicoOrd = mt.toFixed(2)
      }
    },
    'form.fechaETD1': function (val) {
      if (val) {
        if (this.form.fechaETA1 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD1ETA1()
        }
        if (this.form.fechaETA1 !== '' && this.form.fechaETD2 !== '' && this.form.fechaETA2 !== '') {
          this.fechasLlenas = false
        }
        if (this.form.fechaETA1 !== '' && this.form.fechaETD2 !== '' && this.form.fechaETA2 !== '' && (this.atraque && this.atraque.fechaATA && this.atraque.fechaATA !== '') && this.fechaETA3 !== '') {
          this.calculoTransito()
        }
      }
    },
    'form.fechaETA1': function (val) {
      if (val) {
        if (this.form.fechaETD1 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD1ETA1()
        }
        if (this.form.fechaETD2 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETA1ETD2()
        }
        if (this.form.fechaETD1 !== '' && this.form.fechaETD2 !== '' && this.form.fechaETA2 !== '') {
          this.fechasLlenas = false
        }
      }
    },
    'form.fechaETD2': function (val) {
      if (val) {
        if (this.form.fechaETA1 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETA1ETD2()
        }
        if (this.form.fechaETA2 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD2ETA2()
        }
        if (this.form.fechaETD1 !== '' && this.form.fechaETA1 !== '' && this.form.fechaETA2 !== '') {
          this.fechasLlenas = false
        }
      }
    },
    'form.fechaETA2': function (val) {
      if (val) {
        if (this.form.fechaETD2 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD2ETA2()
        }
        if (this.atraque && (this.atraque.fechaATA && this.atraque.fechaATA !== '')) {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETA2ATA()
        }
        if (this.form.fechaETD1 !== '' && this.form.fechaETA1 !== '' && this.form.fechaETD2 !== '') {
          this.fechasLlenas = false
        }
      }
    },
    'atraque.fechaATA': function (val) {
      if (val) {
        if (this.form.fechaETA2 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETA2ATA()
        }
        if (this.form.fechaETA3 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarATAETA3()
        }
      }
    },
    'form.fechaETA3': function (val) {
      if (val) {
        if (this.form.fechaETD1 !== '' && this.form.fechaETA1 !== '' && this.form.fechaETD2 !== '' && this.form.fechaETA2 !== '' && (this.atraque && this.atraque.fechaATA && this.atraque.fechaATA !== '')) {
          if (!this.validarFechaETA3()) {
            this.calculoTransito()
          }
        } else {
          this.$swal({
            icon: 'error',
            title: 'Error!',
            text: 'Recuerde introducir las fechas anteriores'
          })
          this.form.fechaETA3 = ''
        }
      }
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.permisosImportacion = this.$store.state.usuario.Empresa[0].permisos.find(permiso => permiso.ruta === 'Importacion')
      if (this.permisosImportacion) {
        this.editedIndex = -1
        this.modificar = false
        this.listarImportaciones()
        this.listarTarifa()
        this.listarShipper()
        this.listarConsignado()
        this.listarNaviera()
        this.listarPaises()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Permiso Denegado',
          text: 'No tiene los pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    listarImportaciones () {
      Api.get('importacion/local')
        .then(response => {
          this.importacion = response.data
          console.log('IMPORTACION', response.data)
          this.importacion.map(data => {
            data.fechaETD1 ? data.fechaETD1 = this.formato(data.fechaETD1) : data.fechaETD1 = ''
            data.fechaETA1 ? data.fechaETA1 = this.formato(data.fechaETA1) : data.fechaETA1 = ''
            data.fechaETD2 ? data.fechaETD2 = this.formato(data.fechaETD2) : data.fechaETD2 = ''
            data.fechaETA2 ? data.fechaETA2 = this.formato(data.fechaETA2) : data.fechaETA2 = ''
            data.fechaETA3 ? data.fechaETA3 = this.formato(data.fechaETA3) : data.fechaETA3 = ''
            data.atraque ? data.atraque.fechaATA = this.formato(data.atraque.fechaATA) : data.atraque = {}
            data.importacion.map(dataI => {
              dataI.fechaCyEOrd ? dataI.fechaCyEOrd = this.formato(dataI.fechaCyEOrd) : dataI.fechaCyEOrd = ''
            })
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.loading = false
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.loading = false
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarTarifa () {
      Api.get('/tarifa')
        .then(response => {
          this.tarifas = response.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarShipper () {
      Api.get('/proveedor')
        .then(response => {
          this.proveedor = response.data
          this.proveedor.map(data => {
            this.shipperArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarConsignado () {
      Api.get('/consignado')
        .then(response => {
          this.consignados = response.data
          this.consignados.map(data => {
            this.consigneeArray.push({
              text: data.nombreEmpresa,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarNaviera () {
      Api.get('/naviera')
        .then(response => {
          let arrayAgencia = []
          let arrayNaviera = []
          response.data.map(data => {
            data.tipoN.map(tip => {
              if (tip.includes('Agencia de Carga Internacional')) {
                arrayAgencia.push(data)
                this.agenciaArray.push({
                  text: data.nombreEmpresa,
                  value: data._id
                })
                this.agenciaAtraqueArray.push({
                  text: data.nombreEmpresa,
                  value: data._id
                })
              }
              if (tip.includes('Naviera')) {
                arrayNaviera.push(data)
                this.navieraAtraqueArray.push({
                  text: data.nombreEmpresa,
                  value: data._id
                })
              }
            })
          })
          this.agencias = arrayAgencia
          this.navieras = arrayNaviera
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarPaises () {
      Api.get('/paisesImportacion')
        .then(response => {
          this.pais = response.data
          this.pais.map(data => {
            this.paisETD1Array.push({
              text: data.pais,
              value: data._id
            })
            this.paisETA1Array.push({
              text: data.pais,
              value: data._id
            })
            this.paisETA2Array.push({
              text: data.pais,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    imprimirPDF (item) { // Bus a ImportacionExpediente.vue
      EventBus.$emit('expedienteImportacion', item)
      this.dialogImportacionExpediente = true
    },

    validarETD1ETA1 () {
      if (this.$moment(this.form.fechaETA1) <= this.$moment(this.form.fechaETD1)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 1 no puede ser menor o igual a ETD 1'
        })
        this.form.fechaETD1 = ''
        this.form.fechaETA1 = ''
        return true
      }
      return false
    },
    validarETA1ETD2 () {
      if (this.$moment(this.form.fechaETD2) <= this.$moment(this.form.fechaETA1)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETD 2 no puede ser menor o igual a ETA 1'
        })
        this.form.fechaETA1 = ''
        this.form.fechaETD2 = ''
        return true
      }
      return false
    },
    validarETD2ETA2 () {
      if (this.$moment(this.form.fechaETA2) <= this.$moment(this.form.fechaETD2)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 2 no puede ser menor o igual a ETD 2'
        })
        this.form.fechaETD2 = ''
        this.form.fechaETA2 = ''
        return true
      }
      return false
    },
    validarETA2ATA () {
      if (this.$moment(this.atraque.fechaATA) < this.$moment(this.form.fechaETA2)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ATA no puede ser menor a ETA 2'
        })
        this.form.fechaETA2 = ''
        this.atraque.fechaATA = ''
        this.dialog4 = false
        return true
      }
      return false
    },
    validarATAETA3 () {
      if (this.$moment(this.form.fechaETA3) <= this.$moment(this.atraque.fechaATA)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 3 no puede ser menor o igual a ATA'
        })
        this.atraque.fechaATA = ''
        this.form.fechaETA3 = ''
        this.dialog4 = false
        return true
      }
      return false
    },
    validarFechaETA3 () {
      if (this.$moment(this.form.fechaETA3) <= this.$moment(this.atraque.fechaATA)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 3 no puede ser menor o igual a ATA'
        })
        this.form.fechaETA3 = ''
        return true
      }
      return false
    },

    changePaisETD1 (data) {
      const pt = this.pais.find(pt => pt._id === data)
      this.puertoETD1Array = []
      for (let i = 0; i < pt.puertos.length; i++) {
        this.puertoETD1Array.push(pt.puertos[i].nombrePuerto)
      }
    },
    changePaisETA1 (data) {
      const pt = this.pais.find(pt => pt._id === data)
      this.puertoETA1Array = []
      for (let i = 0; i < pt.puertos.length; i++) {
        this.puertoETA1Array.push(pt.puertos[i].nombrePuerto)
      }
    },
    changePaisETA2 (data) {
      const pt = this.pais.find(pt => pt._id === data)
      this.puertoETA2Array = []
      for (let i = 0; i < pt.puertos.length; i++) {
        this.puertoETA2Array.push(pt.puertos[i].nombrePuerto)
      }
    },
    calculoTransito () {
      this.form.transito = this.$moment(this.form.fechaETA3).diff(this.$moment(this.form.fechaETD1), 'days')
      this.form.diasETD1ETA1 = this.$moment(this.form.fechaETA1).diff(this.$moment(this.form.fechaETD1), 'days')
      this.form.diasETA1ETD2 = this.$moment(this.form.fechaETD2).diff(this.$moment(this.form.fechaETA1), 'days')
      this.form.diasETD2ETA2 = this.$moment(this.form.fechaETA2).diff(this.$moment(this.form.fechaETD2), 'days')
      this.form.diasETA2ETA3 = this.$moment(this.form.fechaETA3).diff(this.$moment(this.form.fechaETA2), 'days')
    },
    calcularDiasRestantes () {
      var fechaActual = this.$moment()
      var restaDias = this.$moment(fechaActual).diff(this.$moment(this.form.atraque.fechaATA), 'days')
      this.form.diasRestantes = parseFloat(this.form.diasLibres) - parseFloat(restaDias)
    },
    infoAtraque () {
      if (this.read === false) {
        if (this.editedIndex !== -1) {
          this.atraque = {
            agencia: this.form.atraque.agencia,
            naviera: this.form.atraque.naviera,
            fechaATA: this.form.atraque.fechaATA,
            barco: this.form.atraque.barco,
            nroViaje: this.form.atraque.nroViaje,
            registroSidunea: this.form.atraque.registroSidunea,
            almacen: this.form.atraque.almacen
          }
          this.dialog4 = true
        }
        this.dialog4 = true
      } else {
        this.atraque = this.form.atraque
        this.dialog4 = true
      }
    },

    validarCrear () {
      return this.permisosImportacion?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosImportacion?.accion.includes('Modificar')
    },

    enterClickedOrden () {
      this.ordenes = []
      if (this.codigoOrden !== '') {
        this.dialogLoading = true
        Api.post('importacion/consultaOrden', { codigoOrd: this.codigoOrden })
          .then((response) => {
            if (response.data.status === 'denied') {
              this.dialogLoading = false
              this.$swal({
                icon: 'error',
                title: 'Error en la busqueda!',
                text: response.data.message
              })
            } else {
              console.log('ORDENES', response.data)
              response.data.map(data => {
                this.ordenes.push({
                  codigoOrd: data.doc_num,
                  fec_emis: this.formato(data.fec_emis),
                  proveedorOrd: data.proveedor,
                  articulos: data.articulos,
                  total_neto: data.total_neto,
                  total_volumen: data.totalVolumen,
                  total_peso: data.totalPeso,
                  total_articulos: data.totalArticulos
                })
              })
              // console.log('ORDENES', this.ordenes)
              this.dialogLoading = false
            }
          })
          .catch((error) => {
            if (error.response) {
              this.dialogLoading = false
              this.$swal({
                icon: 'error',
                title: 'Error',
                text: 'Error encontrado, verifique los datos o llame al administrador.'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    },

    assignItem (item) {
      this.codigoOrden = ''
      let bool = false
      if (this.ordenes2.length > 0) {
        for (let i = 0; i < this.ordenes2.length; i++) {
          if (item.codigoOrd !== this.ordenes2[i].codigoOrd) {
            bool = true
          } else {
            bool = false
            this.$swal({
              icon: 'error',
              title: 'Error de asignación!',
              text: 'La Orden ya se encuentra asignada'
            })
            break
          }
        }
        if (bool) {
          this.importacionAux.codigoOrd = item.codigoOrd
          this.importacionAux.fechaCyEOrd = item.fec_emis
          this.importacionAux.proveedorOrd = item.proveedorOrd
          this.importacionAux.productosOrd = item.articulos
          this.importacionAux.piezasOrd = item.total_articulos
          this.importacionAux.totalOrd = (item.total_neto).toFixed(2)
          this.importacionAux.kilogramosOrd = (item.total_peso).toFixed(2)
          this.importacionAux.piesCubicosOrd = (item.total_volumen).toFixed(2)
          this.importacionAux.metroCubicoOrd = (item.total_volumen / 35.315).toFixed(2)
          this.importacionAux.productosOrd.map((pro) => {
            pro.cantidadRestante = pro.total_art
          })
          this.dialog3 = true
        }
      } else {
        this.importacionAux.codigoOrd = item.codigoOrd
        this.importacionAux.fechaCyEOrd = item.fec_emis
        this.importacionAux.proveedorOrd = item.proveedorOrd
        this.importacionAux.productosOrd = item.articulos
        this.importacionAux.piezasOrd = item.total_articulos
        this.importacionAux.totalOrd = (item.total_neto).toFixed(2)
        this.importacionAux.kilogramosOrd = (item.total_peso).toFixed(2)
        this.importacionAux.piesCubicosOrd = (item.total_volumen).toFixed(2)
        this.importacionAux.metroCubicoOrd = (item.total_volumen / 35.315).toFixed(2)
        this.importacionAux.productosOrd.map((pro) => {
          pro.cantidadRestante = pro.total_art
        })
        this.dialog3 = true
      }
    },

    abrirCalculadora () {
      let array = {}
      if (this.form.calculadora && this.form.calculadora.sub && this.form.calculadora.sub > 0) {
        array = {
          calculadora: this.form.calculadora,
          read: this.read,
          condicion: 'cond2'
        }
      } else {
        array = {
          ordenes2: this.ordenes2,
          peso: this.form.kilogramosGeneralOrd,
          cubicaje: this.form.piesCubicosGeneralOrd,
          piezas: this.form.piezasGeneralOrd,
          sub: this.form.totalGeneralOrd,
          read: this.read,
          condicion: 'cond1'
        }
      }
      EventBus.$emit('dataCalculadora', array)
      this.dialogCalculadora = true
    },

    abrirRoleo () {
      if (this.form.roleo && this.form.roleo.length > 0) {
        console.log('definido')
        this.dialogRoleo = true
      } else {
        if (this.form.fechaETD1 !== '') {
          let array = {
            fechas: {
              fechaETD1: this.form.fechaETD1,
              fechaETA1: this.form.fechaETA1,
              fechaETD2: this.form.fechaETD2,
              fechaETA2: this.form.fechaETA2,
              fechaATA: this.form.atraque.fechaATA,
              fechaETA3: this.form.fechaETA3
            },
            read: this.read
          }
          EventBus.$emit('dataRoleo', array)
          this.dialogRoleo = true
        } else {
          this.$swal({
            icon: 'error',
            title: '¡Fechas vacías!',
            text: 'Recuerde que debe ingresar ETD 1 y ETD 2 para poder generar un roleo'
          })
        }
      }
    },

    showModalOrden () {
      this.manual = true
      this.dialog3 = true
    },

    enterContainer () {
      // this.contenedores = []
      for (let i = 0; i < this.reservaContenedor; i++) {
        this.addNewRow()
      }
    },

    addNewRow () {
      this.contenedores.push({
        contenedorOrd: '',
        selloOrd: '',
        tipoContenedorOrd: 'High Cube',
        capacidadContenedorOrd: 0
      })
    },

    deleteRow (index, row) {
      var idx = this.contenedores.indexOf(row)
      if (idx > -1) {
        this.contenedores.splice(idx, 1)
      }
    },

    changeShipper (data) {
      const shipperSelec = this.proveedor.find(shipperSelec => shipperSelec._id === data)
      this.form.shipper = shipperSelec._id
    },
    changeConsignee (data) {
      this.form.nombreEncargado = ''
      const consigneeSelec = this.consignados.find(consigneeSelec => consigneeSelec._id === data)
      this.form.consignee = consigneeSelec._id
      this.form.nombreEncargado = consigneeSelec.nombreEncargado
    },
    changeAgencia (data) {
      const agenciaSelec = this.agencias.find(agenciaSelec => agenciaSelec._id === data)
      this.form.agencia = agenciaSelec._id
      this.tarifaArray = []
      this.tarifasAux = []
      for (let i = 0; i < this.tarifas.length; i++) {
        if (this.tarifas[i].agencia.nombreEmpresa.includes(agenciaSelec.nombreEmpresa)) {
          this.tarifasAux.push(this.tarifas[i])
          this.tarifaArray.push({
            text: this.tarifas[i].naviera.nombreEmpresa,
            value: this.tarifas[i].naviera._id
          })
        }
      }
    },
    changeTarifa (data) {
      const tarifaSelec = this.tarifasAux.find(tarifaSelec => tarifaSelec.naviera._id === data)
      this.form.naviera = tarifaSelec.naviera._id
      this.form.diasLibres = tarifaSelec.diasLibres
      this.form.fleteOrd = tarifaSelec.flete
      this.form.gastos.depositoG = tarifaSelec.depositoG
      this.form.gastos.estatusDepositoG = tarifaSelec.estatusDepositoG
      this.form.fechaETD1 = this.formato(tarifaSelec.salida)
    },
    changeAgenciaAtraque (data) {
      const agenciaAtraqueSelec = this.agencias.find(agenciaAtraqueSelec => agenciaAtraqueSelec._id === data)
      this.form.atraque.agencia = agenciaAtraqueSelec._id
    },
    changeNavieraAtraque (data) {
      const navieraAtraqueSelec = this.navieras.find(navieraAtraqueSelec => navieraAtraqueSelec._id === data)
      this.form.atraque.naviera = navieraAtraqueSelec._id
    },

    formato (fecha) {
      return fecha.slice(0, 10)
    },

    numberParse (num) {
      return Number.parseFloat(num).toFixed(2)
    },

    showItem (item) {
      this.formOrden = Object.assign({}, item)
      this.dialogDetalleProOrd = true
    },

    editItem (item, bool) {
      console.log('ITEM ', item)
      this.form._id = item._id
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key]
      })
      this.img = item.archivo
      this.editedIndex = this.importacion.indexOf(item)
      this.ordenes2 = item.importacion
      this.contenedores = item.contenedores
      if (this.form.atraque) this.atraque = this.form.atraque
      this.estimado40 = Math.ceil(this.form.piesCubicosGeneralOrd / 2690)
      this.estimado20 = Math.ceil(this.form.piesCubicosGeneralOrd / 1317)

      if (item.agencia) {
        this.form.agencia = item.agencia._id
        this.changeAgencia(item.agencia._id)
      }
      if (item.naviera) {
        this.form.naviera = item.naviera._id
        this.changeTarifa(item.naviera._id)
      }

      if (item.paisETD1) this.changePaisETD1(item.paisETD1._id)
      if (item.paisETA1) this.changePaisETA1(item.paisETA1._id)
      if (item.paisETA2) this.changePaisETA2(item.paisETA2._id)
      this.add = true
      this.read = bool
      if (this.form.llegadaETA2 && this.form.llegadaETA2 === true) {
        this.diasRes = true
        this.calcularDiasRestantes()
      }
      this.dialog = true
    },

    editItem2 (item, bool) {
      if (bool === false) { this.modificar = true }
      this.importacionAux = Object.assign({}, item)
      if (this.editedIndex !== -1) { this.prov = item.proveedorOrd.nombre }
      this.read2 = bool
      this.dialog3 = true
    },

    close () { // cerrar plus
      console.log('PASO 9')
      this.form = Object.assign({}, this.defaultForm)
      this.formOrden = Object.assign({}, this.defaultFormOrden)
      this.$refs.form.resetValidation()
      // this.$refs.form2.resetValidation()
      this.add = false
      this.codigoOrden = ''
      this.reservaContenedor = 0
      this.contenedores = [{
        contenedorOrd: '',
        selloOrd: '',
        tipoContenedorOrd: 'High Cube',
        capacidadContenedorOrd: 0,
        piezasContenedorOrd: 0,
        pesoContenedorOrd: 0,
        piesCubicosContenedorOrd: 0
      }]
      this.atraque = {
        agencia: [],
        naviera: [],
        fechaATA: '',
        barco: '',
        nroViaje: '',
        registroSidunea: '',
        almacen: ''
      }
      this.diasRes = false
      this.fechasLlenas = true
      this.form.diasRestantes = 0
      this.ordenes = []
      this.ordenes2 = []
      this.tarifasAux = []
      this.tarifaArray = []
      this.editedIndex = -1

      /* this.form.naviera = []
      this.form.diasLibres = 0
      this.form.fleteOrd = 0
      this.form.gastos.depositoG = 0
      this.form.gastos.estatusDepositoG = '' */

      // ACOMODAR AGENCIAS Y NAVIERAS

      this.read = false
      this.read2 = false
      this.dialog = false
      console.log('PASO 10')
      console.log(this.form)
    },
    closeDetalleProOrd () { // cerrar productos de orden-factura
      this.dialogDetalleProOrd = false
      setTimeout(() => {
        this.formOrden = Object.assign({}, this.defaultFormOrden)
      }, 300)
    },
    close3 () { // cerrar dialog detalles orden-factura
      this.$refs.form2.resetValidation()
      this.dialog3 = false
      this.modificar = false
      this.importacionAux = {
        proveedorOrd: {
          co_prov: '',
          nombre: '',
          rif: '',
          ciudad: '',
          telefonos: null,
          direccion: '',
          correo: null
        }
      }
      this.manual = false
      this.read2 = false
    },
    closePaso2 () { // cerrar dialog del paso 2
      this.dialogImportacionP2 = false
    },
    closeTodoP2 () { // guardar en el paso 2
      this.dialogImportacionP2 = false
      console.log('FORM', this.form)
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      const data = new FormData()
      Object.keys(this.form).map((key) => {
        if (Array.isArray(this.form[key])) {
          this.form[key].forEach((val) => {
            if (typeof val === 'object' && val !== null) {
              return data.append(`${key}[]`, JSON.stringify(val))
            }
            return data.append(`${key}[]`, val)
          })
        } else if (
          typeof this.form[key] === 'object' &&
          this.form[key] !== null
        ) {
          return data.append(key, JSON.stringify(this.form[key]))
        } else {
          return data.append(key, this.form[key])
        }
      })
      if (this.form.archivo.imageFile) {
        data.append('imagen', this.form.archivo.imageFile)
      }
      console.log('EDITED', this.editedIndex)
      if (this.editedIndex > -1) {
        Api.put('importacion', data)
          .then(response => {
            console.log('MODIFICADO', response.data)
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.listarImportaciones()
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      } else {
        Api.post('importacion', data)
          .then(response => {
            console.log('GUARDO', response.data)
            this.$swal({
              icon: 'success',
              title: 'Inclusion exitosa',
              text: 'Todos los datos han sido guardados'
            })
            this.listarImportaciones()
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    },
    closeSave2 () { // cerrar todo cuando se guardar en paso 4
      console.log('PASO 7')
      this.dialogImportacionP2 = false
      this.listarImportaciones()
      console.log('PASO 8')
      this.close()
    },
    closeCalculadora () { // cerrar dialog de calculadora
      this.dialogCalculadora = false
    },
    finalizarCalculadora (data) { // cerrar dialog de calculadora y blanquear object
      this.form.calculadora = data
      this.dialogCalculadora = false
    },
    closeAtraque () { // cerrar dialog de arraque
      this.dialog4 = false
    },
    closeExpediente () { // cerrar reporte de expediente
      this.dialogImportacionExpediente = false
    },
    closeRoleo () { // cerrar dialog de roleo
      this.dialogRoleo = false
    },

    eliminar (item) {
      this.ordenes2.splice(this.ordenes2.indexOf(item), 1)
      this.form.piezasGeneralOrd = 0
      this.form.totalGeneralOrd = 0
      this.form.kilogramosGeneralOrd = 0
      this.form.piesCubicosGeneralOrd = 0
      this.form.metroCubicoGeneralOrd = 0

      if (this.ordenes2.length > 0) {
        for (let k = 0; k < this.ordenes2.length; k++) {
          this.ordenes2[k].piezasOrd = parseFloat(this.ordenes2[k].piezasOrd)
          this.ordenes2[k].totalOrd = parseFloat(this.ordenes2[k].totalOrd)
          this.ordenes2[k].kilogramosOrd = parseFloat(this.ordenes2[k].kilogramosOrd)
          this.ordenes2[k].piesCubicosOrd = parseFloat(this.ordenes2[k].piesCubicosOrd)
          this.ordenes2[k].metroCubicoOrd = parseFloat(this.ordenes2[k].metroCubicoOrd)

          this.form.piezasGeneralOrd += this.ordenes2[k].piezasOrd
          this.form.totalGeneralOrd += this.ordenes2[k].totalOrd
          this.form.kilogramosGeneralOrd += this.ordenes2[k].kilogramosOrd
          this.form.piesCubicosGeneralOrd += this.ordenes2[k].piesCubicosOrd
          this.form.metroCubicoGeneralOrd += this.ordenes2[k].metroCubicoOrd
        }

        this.estimado40 = Math.ceil(this.form.piesCubicosGeneralOrd / 2690)
        this.estimado20 = Math.ceil(this.form.piesCubicosGeneralOrd / 1317)
        this.form.piezasGeneralOrd = parseFloat((this.form.piezasGeneralOrd).toFixed(2))
        this.form.totalGeneralOrd = parseFloat((this.form.totalGeneralOrd).toFixed(2))
        this.form.kilogramosGeneralOrd = parseFloat((this.form.kilogramosGeneralOrd).toFixed(2))
        this.form.piesCubicosGeneralOrd = parseFloat((this.form.piesCubicosGeneralOrd).toFixed(2))
        this.form.metroCubicoGeneralOrd = parseFloat((this.form.metroCubicoGeneralOrd).toFixed(2))
      } else {
        this.add = false
        this.form.calculadora = {}
        this.form.piezasGeneralOrd = 0
        this.form.totalGeneralOrd = 0
        this.form.kilogramosGeneralOrd = 0
        this.form.piesCubicosGeneralOrd = 0
        this.form.metroCubicoGeneralOrd = 0
        this.estimado40 = 0
        this.estimado20 = 0
      }
    },

    save2 () {
      // validacion de form2
      // if (this.validacionRules2()) {
      if (this.modificar === false) {
        if (this.manual === true) {
          this.importacionAux.ordenManual = true
          this.importacionAux.codigoOrd = 'No Aplica'
        }
        this.ordenes2.push(this.importacionAux)
        this.form.piezasGeneralOrd = 0
        this.form.totalGeneralOrd = 0
        this.form.kilogramosGeneralOrd = 0
        this.form.piesCubicosGeneralOrd = 0
        this.form.metroCubicoGeneralOrd = 0

        for (let k = 0; k < this.ordenes2.length; k++) {
          this.form.piezasGeneralOrd += parseFloat(this.ordenes2[k].piezasOrd)
          this.form.totalGeneralOrd += parseFloat(this.ordenes2[k].totalOrd)
          this.form.kilogramosGeneralOrd += parseFloat(this.ordenes2[k].kilogramosOrd)
          this.form.piesCubicosGeneralOrd += parseFloat(this.ordenes2[k].piesCubicosOrd)
          this.form.metroCubicoGeneralOrd += parseFloat(this.ordenes2[k].metroCubicoOrd)
        }
        this.estimado40 = Math.ceil(this.form.piesCubicosGeneralOrd / 2690)
        this.estimado20 = Math.ceil(this.form.piesCubicosGeneralOrd / 1317)
        this.form.piezasGeneralOrd = parseFloat((this.form.piezasGeneralOrd).toFixed(2))
        this.form.totalGeneralOrd = parseFloat((this.form.totalGeneralOrd).toFixed(2))
        this.form.kilogramosGeneralOrd = parseFloat((this.form.kilogramosGeneralOrd).toFixed(2))
        this.form.piesCubicosGeneralOrd = parseFloat((this.form.piesCubicosGeneralOrd).toFixed(2))
        this.form.metroCubicoGeneralOrd = parseFloat((this.form.metroCubicoGeneralOrd).toFixed(2))

        this.add = true
        this.dialog3 = false
        this.manual = false
        this.importacionAux = {
          proveedorOrd: {
            co_prov: '',
            nombre: '',
            rif: '',
            ciudad: '',
            telefonos: null,
            direccion: '',
            correo: null
          }
        }
      } else {
        for (let i = 0; i < this.ordenes2.length; i++) {
          if (this.ordenes2[i].codigoOrd === this.importacionAux.codigoOrd) {
            this.$set(this.ordenes2, i, this.importacionAux)
          }
        }
        this.form.piezasGeneralOrd = 0
        this.form.totalGeneralOrd = 0
        this.form.kilogramosGeneralOrd = 0
        this.form.piesCubicosGeneralOrd = 0
        this.form.metroCubicoGeneralOrd = 0

        for (let k = 0; k < this.ordenes2.length; k++) {
          this.ordenes2[k].piezasOrd = parseFloat(this.ordenes2[k].piezasOrd)
          this.ordenes2[k].totalOrd = parseFloat(this.ordenes2[k].totalOrd)
          this.ordenes2[k].kilogramosOrd = parseFloat(this.ordenes2[k].kilogramosOrd)
          this.ordenes2[k].piesCubicosOrd = parseFloat(this.ordenes2[k].piesCubicosOrd)
          this.ordenes2[k].metroCubicoOrd = parseFloat(this.ordenes2[k].metroCubicoOrd)

          this.form.piezasGeneralOrd += this.ordenes2[k].piezasOrd
          this.form.totalGeneralOrd += this.ordenes2[k].totalOrd
          this.form.kilogramosGeneralOrd += this.ordenes2[k].kilogramosOrd
          this.form.piesCubicosGeneralOrd += this.ordenes2[k].piesCubicosOrd
          this.form.metroCubicoGeneralOrd += this.ordenes2[k].metroCubicoOrd
        }
        this.estimado40 = Math.ceil(this.form.piesCubicosGeneralOrd / 2690)
        this.estimado20 = Math.ceil(this.form.piesCubicosGeneralOrd / 1317)

        this.form.piezasGeneralOrd = parseFloat((this.form.piezasGeneralOrd).toFixed(2))
        this.form.totalGeneralOrd = parseFloat((this.form.totalGeneralOrd).toFixed(2))
        this.form.kilogramosGeneralOrd = parseFloat((this.form.kilogramosGeneralOrd).toFixed(2))
        this.form.piesCubicosGeneralOrd = parseFloat((this.form.piesCubicosGeneralOrd).toFixed(2))
        this.form.metroCubicoGeneralOrd = parseFloat((this.form.metroCubicoGeneralOrd).toFixed(2))

        this.dialog3 = false
        this.importacionAux = {
          proveedorOrd: {
            co_prov: '',
            nombre: '',
            rif: '',
            ciudad: '',
            telefonos: null,
            direccion: '',
            correo: null
          }
        }
        this.modificar = false
        this.manual = false
      }
      // }
    },
    saveCalculadora (data) {
      this.form.calculadora = data
      this.form.calculadora.peso = parseFloat(this.form.calculadora.peso)
      this.form.calculadora.cubicaje = parseFloat(this.form.calculadora.cubicaje)
      this.form.calculadora.piezas = parseFloat(this.form.calculadora.piezas)
      this.form.calculadora.sub = parseFloat(this.form.calculadora.sub)
      this.dialogCalculadora = false
    },
    saveRoleo () {
      console.log('guardo')
    },
    saveAtraque () {
      if (!this.validarAtraque()) {
        if (this.form.diasLibres > 0) {
          this.form.diasRestantes = 0
          this.diasRes = true
          this.form.atraque = this.atraque
          this.$swal({
            icon: 'info',
            title: '¡Llegada del barco a puerto Venezolano confirmada!',
            text: 'A partir de este punto comenzará el conteo regresivo de los días. ¡Evite retrasos!'
          })
          this.calcularDiasRestantes()
          this.dialog4 = false
        } else {
          this.$swal({
            icon: 'error',
            title: '¡Error en Días Libres!',
            text: 'Debe ingresar los Dias Libres de la naviera para poder continuar.'
          })
          this.form.llegadaETA2 = false
          this.dialog4 = false
          this.atraque = {
            agencia: [],
            naviera: [],
            fechaATA: '',
            barco: '',
            nroViaje: '',
            registroSidunea: '',
            almacen: ''
          }
        }
      }
    },

    validarAtraque () {
      if ((!this.atraque.agencia || this.atraque.agencia === '') || (!this.atraque.naviera || this.atraque.naviera === '') ||
          (!this.atraque.fechaATA || this.atraque.fechaATA === '') || (!this.atraque.barco || this.atraque.barco === '') ||
          (!this.atraque.nroViaje || this.atraque.nroViaje === '') || (!this.atraque.registroSidunea || this.atraque.registroSidunea === '') ||
          (!this.atraque.almacen || this.atraque.almacen === '')) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor, llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    validarOrdenes () {
      if (this.ordenes2.length < 1) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Importación vacía'
        })
        return true
      }
      return false
    },

    validarFechas () {
      if (
        this.$moment(this.form.fechaETD1) < this.$moment(this.form.fechaETA1) && this.$moment(this.form.fechaETA1) < this.$moment(this.form.fechaETD2) &&
        this.$moment(this.form.fechaETD2) < this.$moment(this.form.fechaETA2) && this.$moment(this.form.fechaETA2) < this.$moment(this.form.fechaETA3)
      ) {
        return true
      }
      this.$swal({
        icon: 'error',
        title: 'Error!',
        text: 'Por favor, verifique las fechas para continuar'
      })
      return false
    },

    validacionRules () {
      if (this.$refs.form.validate()) {
        return true
      } else {
        this.$swal.fire(
          'Oops... Formulario Invalido',
          'Por favor, verifique los datos',
          'error'
        )
        return false
      }
    },

    validacionRules2 () {
      if (this.$refs.form2.validate()) {
        return true
      } else {
        this.$swal.fire(
          'Oops... Formulario Invalido',
          'Por favor, verifique los datos',
          'error'
        )
        return false
      }
    },

    paso2 () {
      if (!this.validarOrdenes() /* && this.validarFechas()  && this.validacionRules() */) {
        let array = {}
        this.form.importacion = this.ordenes2
        this.form.contenedores = this.contenedores
        console.log('FORM', this.form)
        array = {
          form: this.form,
          img: this.img,
          editedIndex: this.editedIndex,
          read: this.read
        }
        EventBus.$emit('dataImportacion', array)
        this.dialogImportacionP2 = true
      }
    }
  }
}
</script>

<style lang="scss">
  .inputt {
    padding: 0px 1px 0px 0px;
  }
  .input2 {
    padding: 5px 5px 25px 5px;
  }
  .check {
    margin-bottom: -13px;
    margin-top: -1px;
    margin-left: 15px;
  }
  .tabla {
    margin: 5px;
  }
  .texto {
    color: black;
  }
</style>
